import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Map as LeafletMap, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "../../utils/leaflet-icons";
import "leaflet-fullscreen/dist/leaflet.fullscreen.css";
import "leaflet-fullscreen/dist/Leaflet.fullscreen.min.js";
import "./fullscreen.css";
import L from "leaflet";

import * as actions from "./../../actions/index";
import { selectLocations, selectLocation } from "./../../selectors.js";
import { ApiConfig, API_URL } from "./../../settings";

import MapCluster from "./../../components/MapCluster";
import ChurchPin from "./../../images/churchpin.svg";

class MapWrapper extends Component {
    constructor() {
        super();

        this.state = {
            error: false,
        };
        
        this.mapRef = null;
        
        this.setMapRef = (element) => {
            this.mapRef = element;
        };
    }

    componentDidMount() {
        if (!this.props.single && this.props.locations === null)
            this.getByLocation();
            
        setTimeout(() => {
            if (this.mapRef && this.mapRef.leafletElement) {
                const map = this.mapRef.leafletElement;
                
                try {
                    const fullscreenOptions = {
                        position: "topright",
                        title: "Vis i fullskjerm",
                        titleCancel: "Avslutt fullskjerm",
                        forceSeparateButton: true,
                        content: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" style="display:block; margin:7px auto;">
                            <path d="M4,4 L9,4 M4,4 L4,9" stroke="#555" stroke-width="2" fill="none"/>
                            <path d="M20,4 L15,4 M20,4 L20,9" stroke="#555" stroke-width="2" fill="none"/>
                            <path d="M4,20 L9,20 M4,20 L4,15" stroke="#555" stroke-width="2" fill="none"/>
                            <path d="M20,20 L15,20 M20,20 L20,15" stroke="#555" stroke-width="2" fill="none"/>
                        </svg>`
                    };
                    L.control.fullscreen(fullscreenOptions).addTo(map);
                    
                    setTimeout(() => {
                        try {
                            const fullscreenButton = document.querySelector(".leaflet-control-fullscreen a");
                            if (fullscreenButton) {
                                fullscreenButton.title = "Vis i fullskjerm";
                            }
                        } catch (e) {
                            console.error("Error fixing title:", e);
                        }
                    }, 100);
                } catch (error) {
                    console.error("Error adding fullscreen control:", error);
                }
            }
        }, 1000);
    }

    componentDidUpdate() {
        // Don't refetch after an error: setState in the catch triggers this again,
        // which used to loop requests until the rate limiter blocked the user
        if (this.props.locations === null && !this.state.error) {
            this.getByLocation();
        }
    }

    getByLocation() {
        // Any re-render while the request is in flight would otherwise send a duplicate
        if (this._loading) {
            return;
        }
        this._loading = true;

        axios
            .get(`${API_URL}/api/churches/map-markers`, ApiConfig)
            .then((res) => {
                this._loading = false;
                this.props.setLocations(res.data);
                this.setState({ error: false });
            })
            .catch((err) => {
                this._loading = false;
                console.error("Error ved henting av kartdata", err);
                this.setState({ error: true });
            });
    }

    render() {
        let { locations, location, single } = this.props;
        let locationObj = null;

        if (location !== null && single) {
            locationObj = {
                lat: location.lat,
                lng: location.lng,
            };
        }

        let latlng = locations;
        const defaultCenter = [65, 17];
        const center = locationObj
            ? [locationObj.lat, locationObj.lng]
            : defaultCenter;
        const zoom = locationObj ? 14 : 4;

        return (
            <div>
                <div className="container">
                    <h2 className="page-title">
                        <img
                            className="page-title__icon"
                            src={ChurchPin}
                            alt="Pin ikon for kirker på kart"
                        />
                        Kirkekart
                    </h2>
                </div>
                <div style={{ height: "400px", position: "relative" }}>
                    <LeafletMap
                        ref={this.setMapRef}
                        center={center}
                        zoom={zoom}
                        style={{ height: "100%", width: "100%" }}
                        scrollWheelZoom={true}
                    >
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        {!this.state.error && latlng && (
                            <MapCluster
                                locations={latlng}
                                location={locationObj}
                            />
                        )}
                    </LeafletMap>
                </div>
                {this.state.error && (
                    <div className="maps-loading-wrapper">
                        <div>Det oppstod en feil ved henting av kartdata.</div>
                    </div>
                )}
                {locations === null && !this.state.error && (
                    <div className="maps-loading-wrapper">
                        <div>Laster kartdata...</div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    locations: selectLocations(),
    location: selectLocation(),
});

const mapDispatchToProps = (dispatch) => {
    return {
        setLocations: (locations) => dispatch(actions.setLocations(locations)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MapWrapper);



// WEBPACK FOOTER //
// ./src/containers/MapWrapper/index.js